import { cn } from "@/lib/utils";

export function ChevronIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-1 w-2 text-white", className)}
      viewBox="0 0 8 4"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.774.178L3.996 2.535 1.22.178a.806.806 0 00-1.01 0 .543.543 0 000 .856l3.286 2.788c.28.237.73.237 1.01 0L7.79 1.034a.543.543 0 000-.856c-.28-.231-.738-.237-1.017 0z"
        fill="currentColor"
      />
    </svg>
  );
}
